import request from '@utils/request'
import requestWordpress from '@utils/request-wordpress'
import axios from 'axios'
import _findIndex from 'lodash/findIndex'
import { getCookie, setCookie } from "@utils/cookie";
import { getLocalStorage, setLocalStorage } from "@utils/localStorage";
import router from '@router'
import store from '@store'
import configRequest from "@src/config/request";
import configRequestWordpress from "@src/config/request-wordpress";
import configSSO from "@src/config/sso";
// import intervalToDuration from "date-fns/intervalToDuration";
import isAfter from 'date-fns/isAfter'
import isBefore from "date-fns/isBefore";
import parseISO from "date-fns/parseISO";

export const state = {
  currentMember: null,
  currentMemberPetList: [],
  currentLiffId: '',
  currentInvisibleDialogLineNotify: false,
};

export const mutations = {
  SET_STATE(state, newValue) {
    state = Object.assign(state, newValue);
  },
  SET_CURRENT_MEMBER(state, newValue) {
    state.currentMember = newValue;
    setLocalStorage('site.auth.currentMember', newValue);
    setDefaultAuthHeaders(state);
  },
  SET_CURRENT_MEMBER_PET_LIST(state, newValue) {
    state.currentMemberPetList = newValue;
  },
  SET_CURRENT_LIFF_ID(state, newValue) {
    state.currentLiffId = newValue;
    setLocalStorage('site.auth.liffId', newValue);
  },
  SET_CURRENT_INVISIBLE_DIALOG_LINE_NOTIFY(state, newValue) {
    state.currentInvisibleDialogLineNotify = newValue;
    setLocalStorage('site.auth.invisibleDialogLineNotify', newValue);
  },
  // SET_CURRENT_LEVEL(state,newValue) {
  //   state.currentIsLevel = newValue
  // }
};

export const getters = {
  isLoggedIn(state) {
    return !!state.currentMember
  },
  isLiffInit(state) {
    return !!state.currentLiffId
  },
  isBlock(state) {
    return !!state.currentMember && !!state?.currentMember?.isBlock
  }
};

export const actions = {

  /**
   * 初始化
   * @param commit
   * @param state
   * @returns {Promise<void>}
   */
  async init({ commit, state, getters, dispatch }) {
    const initState = async () => {
      const stateData = {
        currentMember: await getCookie('site.auth.currentMember'),
        currentLiffId: (getLocalStorage('site.auth.liffId') || '').substr(1, (getLocalStorage('site.auth.liffId') || '').length - 2),
        currentInvisibleDialogLineNotify: getLocalStorage('site.auth.invisibleDialogLineNotify') || false,
      };

      commit('SET_STATE', stateData);
    };

    await initState();

    setDefaultAuthHeaders(state);
    // initLiff(state)

    if (getters.isLoggedIn && router.currentRoute.name !== 'member')
    await dispatch('fetchMember')
    // await dispatch('fetchLevel')
    console.log({...router.currentRoute})
  },

  /**
   * 設定會員
   * @param commit
   * @param newValue
   */
  async setCurrentUser({ commit }, newValue) {
    commit('SET_CURRENT_MEMBER', newValue);
    await setCookie('site.auth.currentMember', newValue)
  },

  /**
   * 設定LIFF ID
   * @param commit
   * @param newValue
   */
  setCurrentLiffId({ commit }, newValue) {
    commit('SET_CURRENT_LIFF_ID', newValue);
  },

  /**
   * 設定LINE Notify 公告
   * @param commit
   * @param newValue
   */
   setCurrentInvisibleDialogLineNotify({ commit }, newValue) {
    commit('SET_CURRENT_INVISIBLE_DIALOG_LINE_NOTIFY', newValue);
  },

  /**
   * 登入
   * @param commit
   * @param dispatch
   * @param getters
   * @param phoneCode
   * @param phoneNumber
   * @param verificationCode
   * @returns {*}
   */
  logIn({
    commit,
    dispatch,
    getters
  }, {
    phoneCode,
    phoneNumber,
    verificationCode
  } = {}) {
    return request
      .post('/merchant/member/login', {
        phoneCode,
        phoneNumber,
        verificationCode,
      }, {
        ...configRequest,
        name: 'logIn',
      })
      .then(async (response) => {
        const { items: member } = response;

        commit('SET_CURRENT_MEMBER', member);
        await setCookie('site.auth.currentMember', member);

        return member
      })
  },

  /**
   * 登入檢查
   * @param commit
   * @param state
   * @returns {Promise<unknown>|*}
   */
  checkLogIn({
    commit,
    state
  }) {
    if(!state.currentMember) {
      return Promise.resolve(null);
    }

    return request
      .get('/merchant/member/login/check', {
        ...configRequest,
        name: 'checkLogIn'
      })
      .then(async (response) => {
        const member = response.items;

        commit('SET_CURRENT_MEMBER', member);
        await setCookie('site.auth.currentMember', member);

        return member
      })
      .catch(async (error) => {
        if(error.response && error.response.status === 401) {
          commit('SET_CURRENT_MEMBER', null);
          await setCookie('site.auth.currentMember', null);
        }

        return null
      })
  },

  /**
   * 登出
   * @param commit
   * @param getters
   * @returns {Promise<AxiosResponse<any>>}
   */
  logOut({ commit, dispatch, getters }) {
    return request
      .get('/merchant/member/logout', {
        ...configRequest,
        name: 'logOut'
      })
      .then(async () => {
        if(getters.isLiffInit) {
          // liff.logout();
        }

        commit('SET_CURRENT_MEMBER', null);
        await setCookie('site.auth.currentMember', null);

        commit('SET_CURRENT_MEMBER_PET_LIST', []);
        // dispatch('fetchLevel')
      })
  },

  /**
   * 取得驗證碼
   * @param commit
   * @param dispatch
   * @param getters
   * @param phoneCode
   * @param phoneNumber
   * @param forceSms
   * @returns {*}
   */
  getCode({
    commit,
    dispatch,
    getters
  }, {
    phoneCode,
    phoneNumber,
    g_recaptcha_response,
    forceSms
  } = {}) {
    return request
      .post('/merchant/member/getCode', {
        phoneCode,
        phoneNumber,
        g_recaptcha_response,
        forceSms
      }, {
        ...configRequest,
        name: 'getCode',
        showMessage: false
      })
  },

  /**
   * 取得會員資料
   * @param commit
   * @returns {*}
   */
  fetchMember({
    commit,
    dispatch
  }) {
    return request
      .get('/merchant/member', {
        ...configRequest,
        name: 'fetchMember'
      })
      .then(async (response) => {
        const member = Object.assign({}, state.currentMember, response.items);

        // FIX ME: level
        commit('SET_CURRENT_MEMBER', member);
        // FIX ME: level
        await setCookie('site.auth.currentMember', member);

        return response
      })
  },

  fetchLevel({
    commit,
    state,
    dispatch,
    getters
  }) {
    const isBetween = () => {
      // if(state.currentMember?.level?.title !== '一般會員') {
        const isAfterStartDate = state.currentMember?.level?.statedAt
          ? new Date() >= parseISO(state.currentMember?.level?.statedAt) 
          : true;
        const isBeforeEndDate = state.currentMember?.level?.expiredAt
          ? new Date() <= parseISO(state.currentMember?.level?.expiredAt)
          : true;
        return isAfterStartDate && isBeforeEndDate
      // } else return false
    }
    if(!state.currentMember || !state.currentMember?.level  || !isBetween()) {
      commit("SET_CURRENT_LEVEL", false)
    } else {
      commit("SET_CURRENT_LEVEL", true)
    }
  },
  /**
   * 編輯會員
   * @param commit
   * @param fullName
   * @param gender
   * @param lineId
   * @param email
   * @param shippingInfo
   * @param extraInfos
   * @returns {*}
   */
  storeMember({
    commit,
  }, {
    /* fullName,
    gender,
    phoneNumber,
    lineId,
    email,
    city,
    district,
    address, */

    fullName,
    gender,
    lineId,
    email,
    shippingInfo = [
      {
        name: "",
        phone: "",
        postcode: "",
        city: "",
        district: "",
        address: ""
      }
    ],
    extraInfos 
  } = {}) {
    return request
      .post('/merchant/member/store', {
        fullName,
        gender,
        lineId,
        email,
        shippingInfo,
        extraInfos
      }, {
        ...configRequest,
        name: 'storeMember'
      })
      .then(async () => {
        const member = Object.assign({}, state.currentMember, {
          fullName,
          gender,
          lineId,
          email,
          shippingInfo,
          extraInfos
        });

        commit('SET_CURRENT_MEMBER', member);
        await setCookie('site.auth.currentMember', member);
      })
  },

  /**
   * 上傳會員媒體
   * @param commit
   * @param formData
   * @returns {*}
   */
  uploadMemberMedia({
    commit,
  }, formData) {
    formData.append('merchantAlias', store.state.merchant.currentMerchant.alias);
    return request
      .post('/merchant/member/media/upload', formData, {
        ...configRequest,
        name: 'uploadMemberMedia',
        baseURL: `${window.globalData.APP_ADMIN_URL}api`,
      })
      .then((response) => {
        return response
      })
  },
  // merchantAlias: store.state.merchant.alias
  /**
   * 刪除會員媒體
   * @param commit
   * @param paths
   * @returns {*}
   */
  deleteMemberMedia({
    commit,
  }, paths) {
    return request
      .post('/merchant/member/media/delete', {
        paths
      }, {
        ...configRequest,
        name: 'deleteMemberMedia',
        baseURL: `${window.globalData.APP_ADMIN_URL}api`
      })
      .then((response) => {
        return response
      })
  },

  /**
   * 取得會員寵物列表
   * @param commit
   * @param state
   * @param limit
   * @param search
   * @param page
   * @param useCached
   * @returns {/* Vuex store state */
  fetchMemberPetList({
    commit,
    state
  }, {
    limit = 9,
    page = 1,
    useCached = false,
  } = {}) {
    const cached = state.currentMemberPetList;
    const hasCached = !!cached && cached[0];

    return hasCached && useCached
      ? {
          items: cached
        }
      : request
        .post('/merchant/member/pet/search', {
          limit,
          page
        }, {
          ...configRequest,
          name: 'fetchMemberPetList'
        })
        .then((response) => {
          commit('SET_CURRENT_MEMBER_PET_LIST', response.items);

          return response
        })
  },

  /**
   * 取得會員寵物項目
   * @param commit
   * @param state
   * @param petId
   */
  fetchMemberPetItem({
    commit,
    state
  }, {
    petId,
  } = {}) {
    request
      .get(`/merchant/member/pet/${petId}`, {
        ...configRequest,
        name: 'fetchMemberPetItem'
      })
  },

  /**
   * 編輯會員寵物
   * @param commit
   * @param state
   * @param id
   * @param sizeAlias
   * @param name
   * @param avatar
   * @param gender
   * @param breed
   * @param birthday
   * @param note
   * @param type - [new, edit]
   * @returns {*}
   */
  storeMemberPet({
    commit,
    state
  }, {
    id,
    sizeAlias,
    name,
    avatar,
    gender,
    breed,
    birthday,
    phoneCode,
    phoneNumber,
    note,
  } = {}) {
    return request
      .post('/merchant/member/pet/store', {
        id,
        sizeAlias,
        name,
        avatar: avatar
          ? `/${avatar.replace(window.globalData.APP_ADMIN_URL, '')}`
          : '',
        gender,
        breed,
        birthday,
        note,
        phone: phoneCode && phoneNumber ? `${phoneCode}-${phoneNumber}` : ''
      }, {
        ...configRequest,
        name: 'storeMemberPet'
      })
      .then((response) => {
        const memberPet = response.items;
        const type = id
          ? 'edit'
          : 'add';

        if(type === 'add') {
          commit('SET_CURRENT_MEMBER_PET_LIST', [
            memberPet,
            ...state.currentMemberPetList,
          ]);
        }

        if(type === 'edit') {
          const currentMemberPetList = [...state.currentMemberPetList];

          const index = _findIndex(currentMemberPetList, (item) => {
            return item.id === id;
          });

          currentMemberPetList[index] = memberPet;

          commit('SET_CURRENT_MEMBER_PET_LIST', currentMemberPetList);
        }

        return memberPet
      })
  },

  /**
   * LINE 登入
   * @param commit
   * @param state
   * @param lineId
   * @param showMessage
   */
  lineLogIn({
    commit,
    state
  }, {
    lineId,
    showMessage = false
  } = {}) {
    return request
      .post(`/merchant/member/line/liff/login`, {
        lineId
      }, {
        ...configRequest,
        name: 'lineLogIn',
        showMessage
      })
      .then(async (response) => {
        const { items: member } = response;

        commit('SET_CURRENT_MEMBER', member);
        await setCookie('site.auth.currentMember', member);

        return member
      })
  },

  /**
   * LINE 綁定
   * @param commit
   * @param state
   * @param lineId
   */
  lineBind({
    commit,
    state
  }, {
    lineId
  } = {}) {
    return request
      .post(`/merchant/member/line/liff/bind`, {
        lineId
      }, {
        ...configRequest,
        name: 'lineBind'
      })
  },

  /**
   * LINE Notify 綁定
   * @param commit
   * @param state
   * @param lineId
   */
   lineNotifyBind({
    commit,
    state
  }, {
    code
  } = {}) {
    return request
      .post(`/merchant/member/line/notify/bind`, {
        code
      }, {
        ...configRequest,
        name: 'lineNotifyBind',
      })
  },

  /**
   * LINE Notify 解除綁定
   * @param commit
   * @param state
   * @param lineId
   */
   lineNotifyUnbind({
    commit,
    state
  }) {
    return request
      .post(`/merchant/member/line/notify/unBind`, {}, {
        ...configRequest,
        name: 'lineNotifyUnbind'
      })
  },

  /**
   * 刪除會員寵物
   * @param commit
   * @param state
   * @param ids
   * @returns {*}
   */
  removeMemberPetList({
    commit,
    state
  }, {
    ids = []
  } = {}) {
    return request
      .post('/merchant/member/pet/remove', {
        ids
      }, {
        ...configRequest,
        name: 'removeMemberPetList'
      })
      .then(() => {
        const currentMemberPetList = [...state.currentMemberPetList];

        const index = _findIndex(currentMemberPetList, (item) => {
          return item.id === ids[0];
        });

        currentMemberPetList.splice(index, 1);

        commit('SET_CURRENT_MEMBER_PET_LIST', currentMemberPetList);
      })
  },

  // Wordpress SSO
  wordpressLogIn({ commit, state, dispatch, getters }, redirectTo) {
    /* const localUrl = (router.history.current.query.redirectFrom || '').indexOf('http') !== -1
      ? `${router.history.current.query.redirectFrom}`
      : `${window.location.origin}${router.history.current.query.redirectFrom}`;

    const redirect = router.history.current.query.redirectFrom
      ? localUrl
      : redirectTo; */

    return requestWordpress
      .post('/sso/login', {
        sso_key: configSSO.key,
        phone: state.currentMember.phone,
        api_token: state.currentMember.token,
        redirect: encodeURIComponent(redirectTo)
      }, {
        ...configRequestWordpress,
        name: 'wordpressLogIn',
      })
      .then(response => {
        window.location = response.login_url;
      })
  },

  wordpressLogOut({ commit, state, dispatch, getters }, { redirect }) {
    return requestWordpress
      .post('/sso/logout', {
        redirect: encodeURIComponent(redirect)
      }, { errorHandle: false })
      .then(response => {
        window.location = response.logout_url;
      })
  },
};

// ===
// Private helpers
// ===
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.common.Authorization = state.currentMember
    ? `Bearer ${state.currentMember.token}`
    : ''
}

/*
 function initLiff(state, commit) {
 const liffId = state.currentLiffId;

 if(liffId) {
 setTimeout(() => {
 liff.init({
 liffId
 })
 .then((response) => {
 alert(response)
 })
 .catch((e) => {
 commit('SET_CURRENT_LIFF_ID', null);
 });
 }, 300)
 }
 }
 */

